import { atom } from "recoil";

// [agent]checkup_operation 申込情報表示用
export const orderInfoState = atom({
  key: "orderInfoState",
  default: {
    id: null,
    mtemployee_id: null,
    status: '',
    cource_id: null,
    cource_code: null,
    requestcource: null,
    requestpref_code: '',
    requestpref_name: '',
    requestclinic_id: null,
    requestclinic: null,
    requestdt1: null,
    requestdt1_ampm: '0',
    requestdt2: null,
    requestdt2_ampm: '0',
    requestdt3: null,
    requestdt3_ampm: '0',
    requestnote: '',
    options: [],
    examdt: null,
    examclinic_id: null,
    examvenue_id: null,
    examclinic: '',
    item_id: null,
    staff_users_id: null,
    created_at: null,
    calc_price: '',
    result_price: '',
  },
});
